import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getServer(id) {
        return axios.get(config.publicPath + 'pmta_servers/' + id, {
            headers: JsonHeaders
        });
    },
    getServers(currentPage, perPage, name, user_id) {
        return axios.get(config.publicPath + 'pmta_servers', {
            params: {_page: currentPage, itemsPerPage: perPage, name: name, "user.id": user_id},
            headers: JsonHeaders
        });
    },
    getServerSelect(user_id = null) {
        return axios.get(config.publicPath + 'pmta_servers', {
            params: {'groups[]': 'select', 'user.id': user_id, 'pagination': false},
            headers: JsonHeaders
        });
    },
    createServer(formData) {
        return axios.post(config.publicPath + 'pmta_servers', formData, {
            headers: JsonHeaders
        });
    },
    updateServer(id, formData) {
        return axios.put(config.publicPath + 'pmta_servers/' + id, formData, {
            headers: JsonHeaders
        });
    },
    deleteServer(id) {
        return axios.delete(config.publicPath + 'pmta_servers/' + id, {
            headers: JsonHeaders
        });
    },
    checkSoftware(id) {
        return axios.get(config.publicPath + 'pmta_servers/' + id + '/software_readiness', {
            headers: JsonHeaders
        });
    },
    checkConfigDates(id) {
        return axios.get(config.publicPath + 'pmta_servers/' + id + '/config_dates', {
            headers: JsonHeaders
        });
    },
    uploadConfig(id) {
        return axios.post(config.publicPath + 'pmta_servers/' + id + '/config_upload', {
            headers: JsonHeaders
        });
    },
    uploadServers(data) {
        return axios.post(config.publicPath + 'upload_pmta_servers', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
}
